import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class PAComponiFatturaConfirmController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        'ArchiSmallServices',
        '$uibModal'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
        /* tslint:disable:no-string-literal */
        $scope.pageHeader = 'Componi Fattura Conferma';
        let result = store.get('fatturazionepaComponiFattura-Result');
        if (result === undefined) {
            $state.go('home.home-index');
        }

        $scope.result = result;
        let fileName = $scope.result.FilePath.split(/\/(.+)?/)[1];
        let shortName = $scope.result.FilePath.split('/').pop();
        $scope.settings = {
            'username': $rootScope.currentUser().sub,
            'files': [{
                'file_id': $scope.result.FilePath,
                'file_name': fileName,
                'short_name': shortName
            }],
            'queueId': '',
            'uploadType': $scope.result.uploadType * 1

        };
        $scope.prev = () => {
            switch ($scope.result.uploadType) {
                case 1:
                    $state.go('home.pa-componi-fattura-semplice', { xmlpath: $scope.result.FilePath });
                    break;
                case 2:
                    $state.go('home.pa-componi-fattura', { xmlpath: $scope.result.FilePath });
                    break;
            }
        };
        $scope.next = () => {
            $scope.openComponiFatturaConfirmWorkerChatModal('md');
        };
        // <editor-fold desc='openWorkerChatModal1'>
        $scope.openComponiFatturaConfirmWorkerChatModal = (size) => {
            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'workerComponiFatturaPAConfirmModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    settings: () => {
                        return $scope.settings;
                    }
                }
            });
        };
        // </editor-fold>

        $rootScope.formsubmitted = false;
    }

}

export const PAComponiFatturaConfirmComponent: ng.IComponentOptions = {
    template: require('./pa-componi-fattura-confirm.html'),
    controller: PAComponiFatturaConfirmController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-componi-fattura-confirm/pa-componi-fattura-confirm.ts